import { Reveal, SectionLabel } from "./Reveal";
import { IMAGES } from "../../data";

const TECH = [
  { label: "Motion Capture", metric: "3D markerless kinematics" },
  { label: "Force Plates", metric: "Ground-reaction & drive metrics" },
  { label: "Velocity Tracking", metric: "Release velo, spin & extension" },
];

export const Technology = () => (
  <section
    id="technology"
    data-testid="technology-section"
    className="relative border-t border-white/10 bg-[#080808] py-24 md:py-32"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 md:px-12 lg:grid-cols-2 lg:gap-20">
      <Reveal className="order-2 lg:order-1">
        <SectionLabel>[ Technology & Data ]</SectionLabel>
        <h2 className="mt-5 font-heading text-4xl font-black uppercase leading-none tracking-tight text-white md:text-6xl">
          Feedback loops
          <br />
          beat guesswork
        </h2>
        <p className="mt-6 max-w-lg font-body text-white/60 md:text-lg">
          You can't improve what you don't measure. We capture the mechanics behind your
          velocity — then close the loop with objective re-testing until the numbers move.
        </p>

        <div className="mt-10 space-y-px border-t border-white/10">
          {TECH.map((t, i) => (
            <Reveal
              key={t.label}
              delay={i * 0.1}
              className="group flex items-center justify-between border-b border-white/10 py-5"
            >
              <div className="flex items-center gap-4">
                <span className="font-mono text-xs text-[#00F0FF]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-heading text-xl font-bold uppercase tracking-tight text-white">
                  {t.label}
                </span>
              </div>
              <span className="hidden font-mono text-xs uppercase tracking-wider text-white/40 sm:block">
                {t.metric}
              </span>
            </Reveal>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15} className="order-1 lg:order-2">
        <div className="relative">
          <div className="absolute -inset-3 border border-[#00F0FF]/20" />
          <div
            className="relative overflow-hidden"
            style={{ clipPath: "polygon(0 0, 100% 0, 100% 88%, 92% 100%, 0 100%)" }}
          >
            <img
              src={IMAGES.technology}
              alt="Athletes training in the performance lab"
              className="h-[420px] w-full object-cover grayscale transition-all duration-700 hover:grayscale-0 md:h-[520px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </div>
          <div className="absolute bottom-6 left-6 border border-[#00F0FF]/40 bg-black/60 px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#00F0FF] backdrop-blur-sm">
            <div>CAPTURE RATE // 240 FPS</div>
            <div className="mt-1 text-white/40">DATA POINTS // 1,200+ / REP</div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Technology;
